<template>
	<section class="faq-form">
		<div v-if="!submitted">
			<h3 v-text="$__('form.support.title')"></h3>
			<validationObserver ref="observer" v-slot="{ invalid }" tag="form" @submit.prevent="saveForm">
				<div class="form-group">
					<select class="form-control" id="faqform" v-model="form.category">
						<option value="-" v-text="$__('form.support.category')"></option>
						<option v-for="cat in categories" :value="cat" v-text="cat" :key="cat"></option>
					</select>
				</div>
				<div class="form-row">

						<div class="form-group col-md-6 input-extra">
							<ValidationProvider
								rules="required"
								v-slot="{ errors, failedRules }"
								class="input-name"
								tag="div"
							>
								<input type="text" class="form-control" id="inputname" placeholder="Your name" v-model="form.name" :class="{ 'input-error': errors.length }">
								<label for="inputname" v-text="$__('checkout.form.billing_name')"></label>
								<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.error.generic')"></div>
							</ValidationProvider>

						</div>

					<div class="form-group col-md-6 input-extra">
						<ValidationProvider
							rules="required|email"
							v-slot="{ errors, failedRules }"
							class="input-name"
							tag="div"
						>
							<input type="email" class="form-control" id="inputmail" placeholder="Email" v-model="form.email">
							<label for="inputmail" v-text="$__('checkout.form.billing_email')"></label>
							<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.error.required_email')"></div>
							<div v-else-if="failedRules.email" class="invalid-feedback" v-text="$__('form.error.invalid_email')"></div>
						</ValidationProvider>
					</div>
				</div>
				<div class="form-group input-extra">
					<ValidationProvider
						rules="required"
						v-slot="{ errors, failedRules }"
						class="input-name"
						tag="div"
					>
						<textarea placeholder="Your question" class="form-control" id="inputtextarea" rows="3" v-model="form.question"></textarea>
						<label for="inputtextarea" v-text="$__('form.support.question')"></label>
						<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.error.generic')"></div>
					</ValidationProvider>
				</div>
				<div class="form-group">
					<div class="custom-control custom-checkbox">
						<ValidationProvider
							rules="required"
							v-slot="{ errors, failedRules }"
							class="input-name"
							tag="div"
						>
							<input class="custom-control-input" type="checkbox" id="gridCheck" v-model="form.terms">
							<label class="custom-control-label" for="gridCheck" v-text="$__('form.support.terms')"></label>
							<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.support.terms_error')"></div>
						</ValidationProvider>
					</div>
				</div>
				<button type="submit" :disabled="disabled" class="btn btn-primary btn-lg" v-text="$__('form.support.send')"></button>
			</ValidationObserver>
		</div>
		<div v-else>
			<div class="content">
				<slot name="success"></slot>
			</div>
		</div>
	</section>
</template>

<script>
	// vee-validate
	import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate';
	import { required, email } from 'vee-validate/dist/rules';
	import easydropdown from "easydropdown";

	extend('email', {
		... email, email
	});

	extend('required', {
		...required,
		message: 'This field is required',
	});

	export default {
		name: 'SupportForm',
		props: {
			categories: Array
		},
		data() {
			return {
				form: {
					category: '-',
					lang: window.sharedData.locale
				},
				submitted: false,
				disabled: false
			}
		},
		components: {
			ValidationObserver,
			ValidationProvider
		},
		methods: {
			async saveForm () {
				const isValid = await this.$refs.observer.validate();
				if (!isValid) {
					return false;
				}
				axios.post('/api/form/support', this.form)
					.then(response => {
						if (!response.error) {
							this.disabled = false;
							this.submitted = true;
						}
					})
					.catch(function (error) {
						// error
					});
				return false;
			},
		},
		mounted() {
			const faqForm = document.getElementById('faqform');
			const faqSelect = easydropdown(faqForm);
		}
	}
</script>
